import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#F4F1EB] border-t border-[#E2DCD0]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/assets/logo.png"
                alt="Guardian Grace Foundation"
                className="h-16 w-16 object-contain rounded-full ring-1 ring-[#E2DCD0] bg-[#FAF8F5]"
              />
              <div>
                <div className="font-serif text-2xl text-[#692128] leading-tight">Guardian Grace</div>
                <div className="text-[10px] tracking-[0.22em] uppercase text-[#5C5856]">
                  Family &amp; Community Foundation
                </div>
              </div>
            </div>
            <p className="text-[#5C5856] max-w-md leading-relaxed">
              A faith-grounded, community-centered nonprofit — strengthening families,
              empowering caregivers, and honoring those who serve.
            </p>
          </div>

          <div className="md:col-span-5">
            <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#8B2635] mb-5">
              Explore
            </div>
            <ul className="grid grid-cols-2 gap-2.5 text-[#2C2A29]">
              <li><a href="/#about" className="hover:text-[#692128] transition-colors">Our Story</a></li>
              <li><a href="/#programs" className="hover:text-[#692128] transition-colors">Programs</a></li>
              <li><a href="/#vision" className="hover:text-[#692128] transition-colors">The Hub</a></li>
              <li><a href="/#partners" className="hover:text-[#692128] transition-colors">Partners</a></li>
              <li><a href="/#newsletter" className="hover:text-[#692128] transition-colors">Newsletter</a></li>
              <li><a href="/#contact" className="hover:text-[#692128] transition-colors">Contact</a></li>
              <li><a href="/#donate" className="hover:text-[#692128] transition-colors">Donate</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#E2DCD0] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-sm text-[#5C5856]">
            © {new Date().getFullYear()} Guardian Grace Family &amp; Community Foundation. All rights reserved.
          </p>
          <div className="flex items-center gap-5 text-sm text-[#5C5856]">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[#692128] transition-colors">
              Privacy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#692128] transition-colors">
              Terms
            </Link>
          </div>
        </div>

        <p className="mt-6 text-xs tracking-[0.22em] uppercase text-[#8B2635] font-semibold text-center sm:text-left">
          Compassion · Service · Family · Community · Legacy · Faith
        </p>
      </div>
    </footer>
  );
}
